module.exports = __webpack_public_path__ + "static/media/aquafury-3.fd0b5a7b.jpg";